import { FC, useMemo, memo } from 'react';
import { EdnaWrapper, getCurrentTheme } from '@providers/index';
import ProgressMeter from '@components/ProgressMeter';
import { PasswordStrengthMeterProps } from './types';

/**
 * Password Strength Meter is specifically designed to indicate five stages of strength for passwords.
 * It inherits from `ProgressMeter`.
 *
 * The five possible values go from 0 (worst) to 4 (best).
 */
const PasswordStrengthMeter: FC<PasswordStrengthMeterProps> = ({
  value,
  width,
  className,
  ariaLabel,
}: PasswordStrengthMeterProps) => {
  const {
    colors: { red500, orange500, yellow500, green500 },
  } = getCurrentTheme();

  const strengthLevelColors: Record<typeof value, string> = useMemo(
    () => ({
      0: red500,
      1: red500,
      2: orange500,
      3: yellow500,
      4: green500,
    }),
    [red500, orange500, yellow500, green500]
  );

  return (
    <EdnaWrapper>
      <ProgressMeter
        className={className}
        role="meter"
        max={4}
        value={value}
        width={width}
        color={strengthLevelColors[value]}
        ariaLabel={ariaLabel}
      />
    </EdnaWrapper>
  );
};

export default memo(PasswordStrengthMeter);
